import { createRoot } from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import './theme/tokens.css'
import './index.css'
import App from './App.tsx'
import './theme/focus-overrides.css'
import { createLeitmotifMuiTheme } from './theme/leitmotifMuiTheme'
import { initSentry } from './sentry'
import { SentryErrorBoundary } from './components/SentryErrorBoundary'

// No-op unless VITE_SENTRY_DSN is set at build time (#499).
initSentry()

const muiTheme = createLeitmotifMuiTheme('light')

createRoot(document.getElementById('root')!).render(
  <ThemeProvider theme={muiTheme}>
    <CssBaseline />
    <SentryErrorBoundary>
      <App />
    </SentryErrorBoundary>
  </ThemeProvider>,
)
